/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/display-name,react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import Option from '../../../../components/Option';
import { SendCryptoScreensFlow } from '../../constants';

const OptionsScreen = ({ types, openScreen, isSendCryptoFlow }) => {
  const { t: translate } = useTranslation();

  const renderTitle = () => (
    <div
      className={`w-100 ${isBrowser ? 'd-flex align-items-center justify-content-between' : ''} `}>
      <div>
        <b className="text-f5 text-dark ms-2">{translate('whitelist_address_options_title')}</b>
      </div>
    </div>
  );

  const renderFooter = () => <></>;

  return (
    <ModalBodyLayout
      withBack
      onPrevClick={() =>
        openScreen(
          isSendCryptoFlow
            ? SendCryptoScreensFlow.SEND_CRYPTO
            : SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES
        )
      }
      renderFooter={renderFooter}
      renderTitle={renderTitle}
      title={null}
      isScrollable={false}>
      <div className="d-flex flex-fill flex-column justify-content-start align-content-center h-100">
        <div className="mt-5">
          {types.map((option) => (
            <Option key={option.title} {...option} />
          ))}
        </div>
      </div>
    </ModalBodyLayout>
  );
};

export default OptionsScreen;

OptionsScreen.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
  openScreen: PropTypes.func.isRequired,
  isSendCryptoFlow: PropTypes.bool,
};

OptionsScreen.defaultProps = {
  isSendCryptoFlow: false,
};
